import { render, staticRenderFns } from "./CardSkeleton.vue?vue&type=template&id=019ee509&scoped=true&"
import script from "./CardSkeleton.vue?vue&type=script&lang=js&"
export * from "./CardSkeleton.vue?vue&type=script&lang=js&"
import style0 from "./CardSkeleton.vue?vue&type=style&index=0&id=019ee509&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "019ee509",
  null
  
)

export default component.exports